<template>
  <v-card>
    <v-card-title>
      {{ $t("formula.constant.title") }}
    </v-card-title>

    <v-form
      :lazy-validation="false"
      @submit.prevent="handleSubmit"
      ref="constantForm"
      class="d-flex justify-space-between align-center"
      style="width: 100%"
    >
      <v-card-text>
        <v-text-field
          :label="$t('formula.fields.name')"
          autocomplete="off"
          type="text"
          v-model="localConstant.name"
          :rules="[rules.name]"
        />

        <v-text-field
          :label="$t('formula.fields.value')"
          autocomplete="off"
          type="number"
          v-model="localConstant.value"
          :rules="[rules.name]"
        />

        <v-switch
          v-model="localConstant.isGlobal"
          :label="$t('formula.fields.isGlobal')"
        />
        <v-btn color="primary" type="submit" text>
          {{ $t("common.save") }}
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { defaultConstantFields } from "@/_helpers/formulaHelper";

export default {
  name: "CreateConstantForm",
  props: {
    constantId: {
      type: String,
      default: () => "",
    },
  },

  emits: ["update"],

  computed: {
    ...mapGetters("formulas", ["getConstantById", "getConstantByName"]),
  },

  data() {
    return {
      valid: false,
      localConstant: {},
      rules: {
        name: (v) => !!v || this.$t("validation.requiredSingle"),
      },
    };
  },

  methods: {
    ...mapActions("formulas", ["createOrUpdateConstant"]),
    ...mapActions("alert", ["success", "error"]),

    async handleSubmit() {
      if (!this.$refs.constantForm.validate()) return;

      let constant = await this.getConstantByName(this.localConstant.name);
      if (
        constant != undefined &&
        constant.constantId != this.localConstant.constantId
      ) {
        this.error(this.$t("formula.errors.duplicateNames"));
        return;
      }

      try {
        (await this.createOrUpdateConstant(this.localConstant))
          ? this.success(this.$t("common.updated"))
          : this.error(this.$t("common.error"));
      } catch (error) {
        console.error(error);
      }
      this.$emit("update");
    },
  },

  created() {
    let constant = this.getConstantById(this.constantId);
    this.localConstant =
      constant != undefined ? constant : defaultConstantFields;
  },

  watch: {
    constantId: {
      handler(value) {
        let constant = this.getConstantById(value);
        this.localConstant =
          constant != undefined ? constant : defaultConstantFields;
        this.$refs.constantForm.resetValidation();
      },
      deep: true,
    },
  },
};
</script>
